import { motion } from "framer-motion";
import { Quote } from "lucide-react";

interface Testimonial {
  id: number;
  quote: string;
  author: string;
  role: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    quote: "Chito transformed how I manage my chit funds. Everything is so streamlined now!",
    author: "Rahul Sharma",
    role: "Chit Fund Organizer"
  },
  {
    id: 2,
    quote: "The automated reminders saved me countless hours of manual follow-ups with members.",
    author: "Priya Patel",
    role: "Finance Manager"
  },
  {
    id: 3,
    quote: "Tracking payments and disbursals has never been easier. Highly recommend!",
    author: "Suresh Kumar",
    role: "Small Business Owner"
  }
];

const TestimonialsSection = () => {
  return (
    <section className="py-16 px-4 md:px-8 bg-gradient-to-br from-primary/5 via-background to-accent/5">
      <div className="max-w-7xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 30 }} // Added y: 30
          whileInView={{ opacity: 1, y: 0 }} // Changed from just opacity: 1
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold mb-4">What Our Users Say</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Don't just take our word for it. See what our customers have to say about Chito.
          </p>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 30 }} // Increased y from 20 to 30
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-card p-6 rounded-lg shadow-sm border relative"
            >
              <div className="absolute -top-4 -left-2 w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                <Quote className="h-4 w-4 text-primary" />
              </div>
              <p className="mt-4 italic text-foreground">{testimonial.quote}</p>
              <div className="mt-6 flex items-center">
                <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-primary-foreground font-semibold">
                  {testimonial.author.charAt(0)}
                </div>
                <div className="ml-3">
                  <p className="font-medium">{testimonial.author}</p>
                  <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
